import { connect } from 'react-redux';
import shpwrite from 'shp-write-update';
import * as actionsCouples from '../../actions/CouplesActions';
import {
  setIQ100BReportsModalVisibility,
  setUserDeviceReportModalVisibility,
} from '../../actions/MobileStateAction';
import {
  downloadPressureAlertsReport,
  downloadReport,
  downloadSensorsMaintenanceReport,
  downloadSensorsOperationsReport,
  downloadPressureSensorsReport,
  downloadUsersReport,
} from '../../actions/ReportsActions';
import * as sensorsActions from '../../actions/SensorsActions';
import { openSensorSamplesReport } from '../../actions/SensorsSamplesActions';
import TableActions from '../../components/TableActions/TableActions';
import {
  setAlertsStatusChangesSummaryModalVisibility,
  setUsersAlertsManagmentReportModalVisibility,
} from '../../actions/CustomersActions';
import en from '../../translations/en.json';
import he from '../../translations/he.json';
import es from '../../translations/es.json';
import fr from '../../translations/fr.json';
import it from '../../translations/it.json';
import ch from '../../translations/ch.json';

const translationsByLang = {
  en,
  he,
  es,
  fr,
  it,
  ch,
};

const getTranslation = (lang, key, fallback) =>
  translationsByLang[lang]?.[key] || translationsByLang.en?.[key] || fallback;

const mapStateToProps = (state, ownProps) => {
  const user = state.leaksList.user;
  const path = state.routing.locationBeforeTransitions.pathname.replace(
    '/',
    ''
  );
  const selectedProjectId = state.leaksList.selectedProject;
  const projectState = state.leaksList.leaksByProject[selectedProjectId];
  const sensorsContext =
    projectState && projectState.sensors
      ? projectState.sensors.sensorsContext
      : 'LeaksSensors';
  const installContext = state.install.installContext;
  const isPressureSensors =
    sensorsContext === 'PressureSensors' ||
    installContext === 'PressureSensors';
  return {
    ...ownProps,
    user,
    path,
    sensorsContext,
    installContext,
    isPressureSensors,
  };
  // return Object.assign({}, {user}, ownProps);
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const type = ownProps.type;

  return {
    exportProject: (downloadType) => {
      if (type === 'manage') {
        // Users table: export the rows as displayed (after local text filtering)
        return dispatch(downloadUsersReport(ownProps.getUsers()));
      } else if (type === 'pressure') {
        return dispatch(downloadPressureAlertsReport());
      } else if (type === 'sensors') {
        // Dispatch a thunk to check context and export appropriate data
        return dispatch((dispatch, getState) => {
          const state = getState();
          const selectedProjectId = state.leaksList.selectedProject;
          const projectState =
            state.leaksList.leaksByProject[selectedProjectId];
          const sensorsContext =
            projectState && projectState.sensors
              ? projectState.sensors.sensorsContext
              : 'LeaksSensors';
          const installContext = state.install.installContext;
          const isPressureSensors =
            sensorsContext === 'PressureSensors' ||
            installContext === 'PressureSensors';

          if (isPressureSensors) {
            // Export pressure sensors
            return dispatch(downloadPressureSensorsReport());
          } else {
            // Export regular sensors
            return dispatch(downloadReport(type, false, downloadType));
          }
        });
      } else {
        // console.log('downloadType', downloadType);
        return dispatch(downloadReport(type, false, downloadType));
      }
    },
    exportAll: (values, props) => {
      if (type === 'pressure') {
        dispatch(downloadPressureAlertsReport(true));
      } else {
        dispatch(downloadReport(type, true));
      }
    },

    exportAllHistory: () => {
      dispatch(downloadReport('projectHistory'));
    },

    exportSensorsMaintenance: () => {
      dispatch((dispatch, getState) => {
        const stateLanguage = getState().i18nState?.lang || 'en';
        const callback = (error, haveData) => {
          if (error) {
            if (ownProps.notify) {
              ownProps.notify(error.message, 'error');
            }
          } else if (haveData) {
            ownProps.notify(
              getTranslation(stateLanguage, 'downloading', 'Downloading...'),
              'info'
            );
          } else {
            ownProps.notify(
              getTranslation(
                stateLanguage,
                'no_data_available_for_maintenance_report',
                'No data available for the Maintenance report'
              ),
              'info'
            );
          }
        };
        return dispatch(downloadSensorsOperationsReport(callback));
      });
    },
    exportPressureAlerts: (from, to) => {
      // console.log(`from: ${from} - to: ${to}`)
      // dispatch(downloadPressureAlertsReport(from, to));
    },
    loadSensorsActivityData: () => {
      // dispatch(sensorsActions.getSensorsActivityData());
      dispatch(sensorsActions.setSensorsActivityModalVisibility(true));
    },
    openSamplesReport: () => {
      // Open pre-filled with the currently selected sensor row, if any.
      dispatch((dispatch, getState) => {
        const selectedFeature =
          getState().leaksList.leaksByProject.selectedFeature;
        dispatch(
          openSensorSamplesReport(
            selectedFeature != null ? [String(selectedFeature)] : []
          )
        );
      });
    },
    loadTechnicianData: () => {
      dispatch(sensorsActions.setSensorsTechnicianModalVisibility(true));
    },
    exportSensorMaintenanceReport: () => {
      dispatch((dispatch, getState) => {
        const stateLanguage = getState().i18nState?.lang || 'en';
        const callback = (error, haveData) => {
          if (error) {
            if (ownProps.notify) {
              ownProps.notify(error.message || error, 'error');
            }
          } else if (haveData) {
            if (ownProps.notify) {
              ownProps.notify(
                getTranslation(stateLanguage, 'downloading', 'Downloading...'),
                'info'
              );
            }
          } else if (ownProps.notify) {
            ownProps.notify(
              getTranslation(
                stateLanguage,
                'no_data_available_for_maintenance_report',
                'No data available for the Maintenance report'
              ),
              'info'
            );
          }
        };
        return dispatch(
          downloadSensorsMaintenanceReport(callback, 'maintenance_report')
        );
      });
    },
    loadIQ100BReportsData: () => {
      // dispatch(sensorsActions.getSensorsActivityData());
      dispatch(setIQ100BReportsModalVisibility(true));
    },
    loadUserDeviceReportData: () => {
      dispatch(setUserDeviceReportModalVisibility(true));
    },
    openUsersAlertsManagmentReport: () => {
      dispatch(setUsersAlertsManagmentReportModalVisibility(true));
    },
    openAlertsStatusChangesSummaryReport: () => {
      dispatch(setAlertsStatusChangesSummaryModalVisibility(true));
    },
    exportCouplesShapeFile: () => {
      dispatch(actionsCouples.getCouplesPathsGeoJson()).then((geoData) => {
        const projectName = geoData.project.ShortName;
        const options = (type) => ({
          folder: `aqs_${projectName.toLowerCase()}_shape_${type}`,
          file: `${geoData.project.ShortName}_${type}`,
          types: {
            point: 'aqs_points',
            polygon: 'aqs_polygons',
            polyline: 'aqs_lines',
          },
        });

        // shpwrite.download(geoData.geoJSON, options);
        shpwrite.download(geoData.geos.sops, options('installation_points'));
        shpwrite.download(geoData.geos.sensors, options('sensors'));
        shpwrite.download(
          geoData.geos.notInstalledSenosrs,
          options('not_installed_sensors')
        );
        shpwrite.download(geoData.geos.couples, options('couples'));
      });
    },
  };
};

const CTableActions = connect(
  mapStateToProps,
  mapDispatchToProps
)(TableActions);

export default CTableActions;
